export default "/static/webpack/media/watch.cf9c2fbe.svg";